import type { useZero } from "@rocicorp/zero/react";
import { nanoid } from "nanoid";
import { sharedMutators } from "../../shared/mutators";
import { addOptimisticStepExecution } from "../hooks/optimisticStepExecutions";

type RunStepArgs = {
  workflowId: string;
  branchId: string;
  commitId: string;
  stepDir: string;
  ephemeral: boolean;
};

export function runStepOptimistically(
  z: ReturnType<typeof useZero>,
  { workflowId, branchId, commitId, stepDir, ephemeral }: RunStepArgs
) {
  const runId = nanoid(12);
  const executionId = nanoid(12);
  const discard = addOptimisticStepExecution({
    id: executionId,
    runId,
    workflowId,
    branchId,
    stepDir,
    kind: "run",
    purpose: "step",
    buildKey: stepDir,
    status: "pending",
    createdAt: Date.now(),
    startedAt: null,
    completedAt: null,
    duration: null,
    outputContentType: null,
    sourceExecutionId: null,
    commitId,
    contentHash: null,
    codeHash: null,
    run: { ephemeral, interactive: true, commit: null },
    result: null,
    testSpecs: [],
  });
  const result = z.mutate(
    sharedMutators.runStep({
      runId,
      workflowId,
      commitId,
      stepDir,
      executionId,
      ephemeral,
    })
  );
  void result.server.then((serverResult) => {
    if (serverResult.type === "error") discard();
  });
  return executionId;
}
